/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Unlinkcontent1Inputs */

const zh_course_unlinkcontent1 = /** @type {(inputs: Course_Unlinkcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消关联`)
};

const en_course_unlinkcontent1 = /** @type {(inputs: Course_Unlinkcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink Content`)
};

const es_course_unlinkcontent1 = /** @type {(inputs: Course_Unlinkcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desvincular contenido`)
};

/**
* | output |
* | --- |
* | "Unlink Content" |
*
* @param {Course_Unlinkcontent1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_unlinkcontent1 = /** @type {((inputs?: Course_Unlinkcontent1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Unlinkcontent1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_unlinkcontent1(inputs)
	if (locale === "en") return en_course_unlinkcontent1(inputs)
	return es_course_unlinkcontent1(inputs)
});
export { course_unlinkcontent1 as "course_unlinkContent" }